export const Designation: string[] = [
    'CAD Engineer',
    'CAE Engineer',
    'HBD / CFO',
    'Chief Business Development officer',
    'Chief Technical Officer',
    'Design Engineer',
    'HR Manager',
    'HR Recruiter',
    'Human Resource Business Partner',
    'Lead Design Engineer',
    'Senior Lead Engineer',
    'Lead Engineer',
    'Lead System Administrator',
    'Senior CAE Engineer',
    'Senior Design Engineer',
    'System Administrator',
    'Senior Manager',
    'Senior Manager Design',
    'Technical support Assistant',
    'GET',
    'Office Boy',
    'BD Intern',
    'BD Executive',
    'Executive HR BP',
    'Admin',
    'Talent Acquisition Specialist',
    'Account',
    'Account Manager',
    'KBE Engineer',
    'Quality Engineer',
    'Quality Inspector Engineer',
    'Front Desk Executive',
    'Project Manager',
    'MODULE LE',
    'MODULE Manager',
    'AI Engineer',
    'DET'
]